import { useEffect, useRef } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { ENV_CONFIG } from 'config/environment';
import { env } from 'config/environment/env_schema/env';
import { datadogLogs } from '@datadog/browser-logs';

const Login = () => {
  const fullPages = useRef<any>();
  const { loginWithRedirect } = useAuth0();

  useEffect(() => {
    document.body.classList.toggle('login-page');
    return function cleanup() {
      document.body.classList.toggle('login-page');
    };
  });

  useEffect(() => {
    loginWithRedirect({
      authorizationParams: {
        audience: env.REACT_APP_AUTH0_AUDIENCE_V2,
        scope: env.REACT_APP_AUTH0_SCOPE_V2,
        redirect_uri: `${ENV_CONFIG().SITE_URL}/dashboard`,
      },
    }).then(() => {
      //logged in. you can get the user profile like this:
      datadogLogs.logger.debug('User logged in');
    });
  }, []);

  return (
    <div className="wrapper wrapper-full-page" ref={fullPages}>
      <div className="full-page section-image">
        <div className="login-page">
          <div className="full-page-background" />
        </div>
      </div>
    </div>
  );
};

export default Login;
